import { render, staticRenderFns } from "./PaymentTermsEditForm.vue?vue&type=template&id=cad55ec2"
import script from "./PaymentTermsEditForm.vue?vue&type=script&lang=js"
export * from "./PaymentTermsEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports